enum AssetType {
  LOGO = 'LOGO',
  LOGO_BW = 'LOGO_BW',
  PROMO = 'PROMO',
  PROMO_DELIVERED = 'PROMO_DELIVERED',
  RECOMMENDATION = 'RECOMMENDATION',
  RECOMMENDATION_DELIVERED = 'RECOMMENDATION_DELIVERED',
  SPOTLIGHT_DELIVERED = 'SPOTLIGHT_DELIVERED',
  SPOTLIGHT_VIDEO_DELIVERED = 'SPOTLIGHT_VIDEO_DELIVERED',
}

type JSONAsset = {
  draft_image_url: string;
  image_url: string;
  link_url: Maybe<string>;
  object_id: string;
  rank: Maybe<number>;
  title: Maybe<string>;
  type: string;
};

type Asset = {
  draftImageUrl: string;
  imageUrl: string;
  linkUrl: Maybe<string>;
  objectId: string;
  rank: Maybe<number>;
  title: Maybe<string>;
  type: AssetType;
};

const fromJSON = (jsonAsset: JSONAsset): Asset => ({
  draftImageUrl: jsonAsset.draft_image_url,
  imageUrl: jsonAsset.image_url,
  linkUrl: jsonAsset.link_url,
  objectId: jsonAsset.object_id,
  rank: jsonAsset.rank,
  title: jsonAsset.title,
  type: <AssetType>jsonAsset.type,
});

const toJSON = (asset: OptionalObjectId<Asset>): OptionalObjectIdJSON<JSONAsset> => ({
  draft_image_url: asset.draftImageUrl,
  image_url: asset.imageUrl,
  link_url: asset.linkUrl,
  object_id: asset.objectId,
  rank: asset.rank,
  title: asset.title,
  type: asset.type,
});

export { Asset, AssetType, JSONAsset, fromJSON, toJSON };
